import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParticipantService {
  private baseURL = "http://localhost:9091/Participant/";

  constructor(private http: HttpClient) { }

  createParticipant(userId: string, eventId: string): Observable<any> {
    return this.http.post(this.baseURL + "participate/" + userId + "/" + eventId, null);
  }

  getParticipantsByEventId(eventId: string): Observable<any> {
    return this.http.get(this.baseURL + "participants/" + eventId);
  }

  getParticipantById(participantId: string): Observable<any> {
    return this.http.get(this.baseURL + "participant/" + participantId);
  }

  cancelParticipant(participantId: string): Observable<any> {
    return this.http.delete(this.baseURL + "cancelParticipation/" + participantId);
  }

  countParticipantsByEventId(eventId: string): Observable<any> {
    return this.http.get(this.baseURL + "participants/count/" + eventId);
  }
  checkParticipation(userId: string, eventId: string): Observable<any> {
    return this.http.get(this.baseURL + "participation/" + userId + "/" + eventId);
  }
}
